import { useState, DragEvent, ChangeEvent } from "react";
import { Upload } from "lucide-react"; // Importing the upload icon from lucide-react

export function ImageUploadBox() {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const handleImageChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setSelectedImage(imageUrl);
    }
  };

  const handleDrop = (event: DragEvent<HTMLLabelElement>) => {
    event.preventDefault();
    const file = event.dataTransfer.files?.[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setSelectedImage(imageUrl);
    }
  };

  const handleDragOver = (event: DragEvent<HTMLLabelElement>) => {
    event.preventDefault();
  };

  return (
    <label
      className="flex cursor-pointer flex-col items-center justify-center rounded-lg border-2 border-dotted border-gray-400 p-4 text-gray-600"
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      style={{ width: "250px", height: "150px", textAlign: "center" }}
    >
      <input
        type="file"
        accept="image/*"
        onChange={handleImageChange}
        className="hidden"
      />
      {selectedImage ? (
        <img
          src={selectedImage}
          alt="Uploaded Preview"
          className="h-full w-full rounded-md object-contain"
        />
      ) : (
        <>
          <Upload className="mb-2 text-gray-400" size={32} />{" "}
          {/* Lucide-react Upload Icon */}
          <p className="text-center text-sm">Select an image</p>
        </>
      )}
    </label>
  );
}
